import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useChartPeriod } from '@/hooks';
import { CurrencyValue, formatNumber, LineChart } from '@blockanalitica/ui';
import { useCallback, useMemo, useState } from 'react';

export default function HistoricTabs({ address }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const yAxisConfig = {
    options: {
      scales: {
        y: {
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  };
  const config = updateChartConfigWithPeriod(yAxisConfig);
  const [data, error] = useApi({
    url: `/tokens/base/${address}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const valueFormatter = useCallback(
    (value) => <CurrencyValue value={value} />,
    []
  );

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <LineChart
        key="holders"
        data={data.data}
        datasets={[
          {
            xField: 'date',
            yField: 'holders'
          }
        ]}
        valueFormatter={valueFormatter}
        yScaleValueFormatter={(value) => formatNumber(Number(value))}
        timeFilter={timeFilter}
        config={config}
      />
    );
  }
  return <ChartSkeleton />;
}
